export default __webpack_public_path__ + "static/banner3_mobile-df5316d0be5a2e9b9ea4e04ed876b179.png";